module.exports = __webpack_public_path__ + "img/homeArrowActive.a2dbc342.svg";